import "./Connecting.scss";

const Connecting = (props) => {
  return (
      <div className="connecting">{props.alert}</div>
  );
};

export default Connecting;
